// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const NotificationStyle = css`
  align-items: flex-start;
  display: flex;

  ${(props) =>
    props.status === 'success' ? `border: 2px solid ${props.theme.colorPalette.green[500]};` : ''};
  ${(props) =>
    props.status === 'error' ? `border: 2px solid ${props.theme.colorPalette.red[500]};` : ''};
  ${(props) =>
    props.status === 'info' ? `border: 2px solid ${props.theme.colorPalette.gray[600]};` : ''};
  ${(props) => (props.status === 'warning' ? `border: 2px solid #ffab00;` : '')};

  background-color: ${(props) => props.theme.colorPalette.white};

  ${(props) =>
    props.isError
      ? `
      border: none;
      background-color: ${props.theme.colors.NOTIFICATION.ERROR_BACKGROUND};
      border-radius: ${props.theme.spacing.ELEM_SPACING.XS};`
      : ''}
  ${(props) =>
    props.spc
      ? `border-radius: ${props.theme.spacing.ELEM_SPACING.XS};
         border-width: 1px;
    `
      : ''}

  .notification__image {
    height: ${(props) =>
      props.spc ? props.theme.spacing.ELEM_SPACING.MED : props.theme.spacing.ELEM_SPACING.LRG};
    ${(props) => (props.spc ? `margin-top: ${props.theme.spacing.ELEM_SPACING.XXXS};` : '')}
  }
  .using-unverified {
    margin-top: 10px;
  }
  .close-icon {
    position: absolute;
    right: 0;
    padding: 0px 12px;
    cursor: pointer;
  }
`;
export default NotificationStyle;
